import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthAppointmentHistoryResponse,
	GetHealthAppointmentsHistory,
	GetHealthAppointmentsHistoryParams,
} from 'domain/usecases';

export class RemoteGetAppointmentsHistory implements GetHealthAppointmentsHistory {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthAppointmentHistoryResponse>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthAppointmentsHistoryParams): Promise<GetHealthAppointmentHistoryResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
